import { Brand } from 'effect'

/**
 * Branded identifiers so a FileId can never be passed where a ClientId is expected.
 * Every id is a uuid string at runtime. Money is also a brand (never `number`), defined here
 * so the lint guard and the type system agree even though R0 step 1 carries no money.
 */
export type AccountId = string & Brand.Brand<'AccountId'>
export const AccountId = Brand.nominal<AccountId>()

export type PrincipalId = string & Brand.Brand<'PrincipalId'>
export const PrincipalId = Brand.nominal<PrincipalId>()

export type SeatId = string & Brand.Brand<'SeatId'>
export const SeatId = Brand.nominal<SeatId>()

export type ClientId = string & Brand.Brand<'ClientId'>
export const ClientId = Brand.nominal<ClientId>()

/** Cluster and client are the same row in R0 (PRD-020 §6.1: client has structure single | group). */
export type ClusterId = ClientId

export type FileId = string & Brand.Brand<'FileId'>
export const FileId = Brand.nominal<FileId>()

export type WorkItemId = string & Brand.Brand<'WorkItemId'>
export const WorkItemId = Brand.nominal<WorkItemId>()

export type EventId = string & Brand.Brand<'EventId'>
export const EventId = Brand.nominal<EventId>()

export type PeriodId = string & Brand.Brand<'PeriodId'>
export const PeriodId = Brand.nominal<PeriodId>()

/**
 * Money: a decimal string with an ISO currency, never a JavaScript number.
 * Arithmetic lives in the evidence layer (R2); R0 only carries the type so nothing else is invented.
 */
export type Money = Readonly<{ amount: string, currency: 'USD' }> & Brand.Brand<'Money'>
export const Money = Brand.refined<Money>(
  m => /^-?\d+\.\d{2}$/.test(m.amount),
  m => Brand.error(`Money.amount must be a fixed two-decimal string like "12.50", received ${JSON.stringify(m.amount)}`),
)
